export default __webpack_public_path__ + "static/1920_1930-f36b4e16d725643fe51f7957ba4181fb.jpg";